<div class="d-flex justify-content-center align-items-center">
  <div class="card col-md-10 p-0">
    <div class="card-header bg-primary text-white">
      <div class="card-title">Frequently Asked Questions (FAQ)</div>
    </div>
    <div class="card-body">
      <mat-accordion>
        <mat-expansion-panel *ngFor="let faq of faqs" (opened)="panelOpenState = true"
                             (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{faq.q}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <span>Answer:</span>
          <div [innerHTML]="faq.ans"></div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
